import {
  FETCH_NARRATIVES_REQUEST,
  FETCH_NARRATIVES_SUCCESS,
  FETCH_NARRATIVES_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  narratives: {
      newNarratives: [],
      userFrequentNarratives: [],
      regionalTopNarratives: [],
      hotNarratives: []
  },
  error: null,
  sucess:false
};

const narrativesReducer = (state = initialState, action) => {
  switch (action.type) {
      case FETCH_NARRATIVES_REQUEST:
          return {
              ...state,
              loading: true,
              error: null // Reset error on new request
          };
      case FETCH_NARRATIVES_SUCCESS:
          return {
              ...state,
              loading: false,
              narratives: action.payload,
              error: null,
              
          };
      case FETCH_NARRATIVES_FAILURE:
          return {
              ...state,
              loading: false,
              error: action.payload
          };
      default:
          return state;
  }
};

export default narrativesReducer;
